// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { ManagementGuidelineApi } from '../types/management-guidelines.types';
import { managementGuidelinesHttpApi } from './management-guidelines.api';
import { managementGuidelinesMockApi } from './management-guidelines.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const managementGuidelinesApi: ManagementGuidelineApi = useMock
  ? managementGuidelinesMockApi
  : managementGuidelinesHttpApi;
